import React, {useEffect} from 'react';
import {withJsonFormsControlProps} from '@jsonforms/react';
import {TextInputField} from '@/components/molecules';
import PropTypes from 'prop-types';

const TextInputComponent = (props) => {
  /**
   * @typedef {Object} Props
   * @property {function} handleChange - Function to handle input change.
   * @property {string} label - Label for the input field.
   * @property {Object} data - Data object for the input field.
   * @property {string} path - Path to the data in the object.
   * @property {string} errors - String containing validation errors.
   * @property {Object} schema - JSON schema for the input field.
   * @property {Object} uischema - UI schema for the input field.
   * @property {boolean} required - Indicates if the input field is required.
   * @property {boolean} enabled - Indicates if the input field is enabled.
   * @property {boolean} visible - Indicates if the input field is visible.
   */
  const {
    handleChange,
    label,
    data,
    path,
    errors,
    schema,
    uischema,
    required,
    enabled,
    visible
  } = props;

  useEffect(() => {
    if (!enabled && data) {
      handleChange(path, '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);

  const updateValue = (newVal, isValid) => {
    handleChange(path, schema.type === 'string' ? newVal?.trim() : newVal);
    handleChange(path + 'Valid', isValid);
  };

  return (
    <TextInputField
      value={data}
      disabled={!enabled}
      label={uischema.showLabel === false ? '' : label}
      updateValue={updateValue}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
      visible={visible}
    />
  );
};

TextInputComponent.propTypes = {
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  path: PropTypes.string.isRequired,
  errors: PropTypes.string,
  schema: PropTypes.object.isRequired,
  uischema: PropTypes.object,
  required: PropTypes.bool,
  enabled: PropTypes.bool,
  visible: PropTypes.bool
};

const TextInputControl = withJsonFormsControlProps(TextInputComponent);
export default React.memo(TextInputControl);
